import React, { useEffect, useState } from 'react';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import Table from '../../../../components/table/Table';
import {
  roundUpToFirstDecimalPlace,
  roundUpToNextHalf,
} from '../../../../utils/mathUtils';
import { connect } from 'react-redux';
import { setCurrentAuftragspositionen } from '../../../../redux/actions/auftragserfassung';
import { AuftragPositionModel } from '../../../../models/AuftragPositionModel';
import { getLademittelOnlyGGVSOrWithout } from '../../../../redux/actions/lademittel';
import { LademittelModel } from '../../../../models/LademittelModel';
import { getVerpackungenOnlyGGVSOrWithout } from '../../../../redux/actions/verpackungen';
import { VerpackungModel } from '../../../../models/VerpackungModel';
import { initAuftragsPosTableConfig } from './AuftragspositionenTableConfig';
import { toSelectOptions } from '../../../../components/select/SelectModel';
import { StateModel } from '../../../../redux/store';
import { WaehrungModel } from '../../../../models/WaehrungModel';
import { getWaehrungen } from '../../../../redux/actions/waehrungen';
import { MandantSummary } from '../../../../api';
import { nameof } from '../../../../utils/objectUtils';
import {
  VERPACKUNGSEINHEIT_LADEMITTEL,
  VERPACKUNGSEINHEIT_VERPACKUNG,
} from '../../../../models/VerpackungseinheitModel';
import { ConfigModel } from '../../../../models/ConfigModel';
import { initAuftragsPosTableConfigMMT } from './AuftragspositionenTableConfig_MMT';
import { initAuftragsPosTableConfigMetro } from './AuftragspositionenTableConfigMetro';
import { initAuftragsPosTableConfigBEXity } from './AuftragspositionenTableConfigBEXity';
import { initAuftragsPosTableConfigGerstlauer } from './AuftragspositionenTableConfig_Gerstlauer';
import { GERSTLAUER, MMT } from '../../admin/client-config-assembler';

interface AuftragspositionenProps {
  resetToggle: boolean;
  currentAuftragspositionen: AuftragPositionModel[];
  setCurrentAuftragspositionen: (
    auftragspositionen: AuftragPositionModel[]
  ) => void;
  lademittel: Array<LademittelModel>;
  getVerpackungenOnlyGGVSOrWithout: (
    mandantId: number,
    isGGVS: boolean | undefined
  ) => void;
  getLademittelOnlyGGVSOrWithout: (
    mandantId: number,
    isGGVS: boolean | undefined
  ) => void;
  verpackungen: Array<VerpackungModel>;
  getWaehrungen: () => void;
  waehrungen: Array<WaehrungModel>;
  mandant?: MandantSummary;
  isMetro: boolean;
  isBexity: boolean;
  config: ConfigModel;
}

/**
 * Component fuer die Auftragsposition  Tabelle.
 *
 * @returns {JSX.Element}
 */
const Auftragspositionen = ({
  resetToggle,
  currentAuftragspositionen,
  setCurrentAuftragspositionen,
  lademittel,
  getVerpackungenOnlyGGVSOrWithout,
  getLademittelOnlyGGVSOrWithout,
  verpackungen,
  getWaehrungen,
  waehrungen,
  mandant,
  config,
  isMetro,
  isBexity,
}: AuftragspositionenProps) => {
  const initPosTableConfig = () => {
    if (isMetro) {
      return initAuftragsPosTableConfigMetro(
        config.mandantSpezi29,
        config.isLaengePflichtfeld,
        config.isBreitePflichtfeld,
        config.isHoehePflichtfeld,
        waehrungen,
        lademittel,
        verpackungen
      );
    }

    if (isBexity) {
      return initAuftragsPosTableConfigBEXity(
        config.mandantSpezi29,
        config.isLaengePflichtfeld,
        config.isBreitePflichtfeld,
        config.isHoehePflichtfeld,
        waehrungen,
        lademittel,
        verpackungen
      );
    }
    if (config.auftragsresearchtableconfig === MMT) {
      return initAuftragsPosTableConfigMMT(
        config.mandantSpezi29,
        config.isLaengePflichtfeld,
        config.isBreitePflichtfeld,
        config.isHoehePflichtfeld,
        waehrungen,
        lademittel,
        verpackungen
      );
    }
    if (config.auftragsresearchtableconfig === GERSTLAUER) {
      return initAuftragsPosTableConfigGerstlauer(
        config.mandantSpezi29,
        config.isLaengePflichtfeld,
        config.isBreitePflichtfeld,
        config.isHoehePflichtfeld,
        waehrungen,
        lademittel,
        verpackungen
      );
    }
    return initAuftragsPosTableConfig(
      config.mandantSpezi29,
      config.isLaengePflichtfeld,
      config.isBreitePflichtfeld,
      config.isHoehePflichtfeld,
      waehrungen,
      lademittel,
      verpackungen
    );
  };

  const [tableConfig, setTableConfig] = useState(initPosTableConfig());
  const [selectedRow, setSelectedRow] = useState<number | undefined>(undefined);

  const reset = () => {
    setCurrentAuftragspositionen(initData());
    init();
  };

  const init = () => {
    getLademittelOnlyGGVSOrWithout(
      mandant?.id ?? -1,
      config.isNoADRLademittel ? false : undefined
    );
    getVerpackungenOnlyGGVSOrWithout(
      mandant?.id ?? -1,
      config.isNoADRVerpackungen ? false : undefined
    );
    getWaehrungen();
  };

  useEffect(() => {
    const tmpColumnConfig = [...tableConfig];
    const verpackungIndex = tmpColumnConfig.findIndex(
      configEntry => configEntry.attributName === 'verpackung'
    );
  }, [tableConfig]);

  useEffect(() => {
    const lademitteltmp = [...lademittel];
    const tmpColumnConfig = [...tableConfig];
    const lademittelIndex = tmpColumnConfig.findIndex(
      configEntry => configEntry.attributName === 'lademittel'
    );
    tmpColumnConfig[lademittelIndex] = {
      ...tmpColumnConfig[lademittelIndex],
      selectData: toSelectOptions(
        lademitteltmp,
        'kurzBezeichnung',
        true,
        false,
        'langBezeichnung'
      ),
    };
    setTableConfig(tmpColumnConfig);
  }, [lademittel]);

  useEffect(() => {
    const tmpColumnConfig = [...tableConfig];
    const verpackungIndex = tmpColumnConfig.findIndex(
      configEntry => configEntry.attributName === 'verpackung'
    );
    tmpColumnConfig[verpackungIndex] = {
      ...tmpColumnConfig[verpackungIndex],
      selectData: toSelectOptions(
        config.mandantSpezi29 ? [...verpackungen, ...lademittel] : verpackungen,
        'kurzBezeichnung',
        true,
        false,
        'langBezeichnung'
      ),
    };
    setTableConfig(tmpColumnConfig);
  }, [verpackungen]);

  useEffect(() => {
    const waehrungentmp = [...waehrungen];
    const tmpColumnConfig = [...tableConfig];
    const warenwertWaehrungIndex = tmpColumnConfig.findIndex(
      configEntry => configEntry.attributName === 'warenwertWaehrung'
    );
    tmpColumnConfig[warenwertWaehrungIndex] = {
      ...tmpColumnConfig[warenwertWaehrungIndex],
      selectData: toSelectOptions(waehrungentmp, 'bezeichnungKurz'),
    };
    const waehrungVersicherungwertIndex = tmpColumnConfig.findIndex(
      configEntry => configEntry.attributName === 'waehrungVersicherungswert'
    );
    tmpColumnConfig[waehrungVersicherungwertIndex] = {
      ...tmpColumnConfig[waehrungVersicherungwertIndex],
      selectData: toSelectOptions(waehrungentmp, 'bezeichnungKurz'),
    };
    setTableConfig(tmpColumnConfig);
  }, [waehrungen]);

  useEffect(() => {
    if (!currentAuftragspositionen || currentAuftragspositionen?.length == 0)
      reset();
  }, [resetToggle, mandant]);

  useEffect(() => {
    setPositionsNr();
  }, [currentAuftragspositionen]);

  const auftragspositionIsEmpty = (
    auftragsposition: AuftragPositionModel
  ): boolean => {
    return (
      !auftragsposition.verpackungAnzahl &&
      !auftragsposition.verpackung &&
      !auftragsposition.lademittelAnzahl &&
      !auftragsposition.lademittel &&
      !auftragsposition.verpackungseinheit &&
      !auftragsposition.bruttoGewicht &&
      !auftragsposition.mitGefahrguetern &&
      !auftragsposition.zeichenNummer &&
      !auftragsposition.lieferschein &&
      !auftragsposition.versicherungswert &&
      !auftragsposition.waehrungVersicherungswert &&
      !auftragsposition.warenwert &&
      !auftragsposition.warenwertWaehrung &&
      !auftragsposition.lademeter &&
      !auftragsposition.anzahlStellplaetze &&
      !auftragsposition.volumenCBM &&
      !auftragsposition.laengeCM &&
      !auftragsposition.breiteCM &&
      !auftragsposition.hoeheCM
    );
  };

  /**
   * Setzt programmatisch die Nr. der Auftragsposition.
   * -------------
   * 4 Fälle:
   * 1. positionsNummer gesetzt und Auftragsposition leer
   *  -> loeschen und updaten
   * 2. positionsNummer nicht gesetzt und Auftragsposition nicht leer
   *  -> positionsNummer hinzufuegen und updaten
   * 3. positionsNummer gesetzt und Auftragsposition nicht leer
   *  -> nichts tun
   * 4. positionsNummer nicht gesetzt und Auftragsposition leer
   *  -> nichts tun,
   *     eine leere Zeile ist immer in Form der
   *     defaultRow durch die Tabelle enthalten
   */
  const setPositionsNr = () => {
    let shouldUpdate = false;

    const tmpAuftragspositionen = [...currentAuftragspositionen]
      .filter(auftragsposition => {
        if (
          // Fall 1, wird durch .filter herausgefiltert,
          // anschließend muss geupdated werden
          auftragsposition.auftptNum &&
          auftragspositionIsEmpty(auftragsposition)
        ) {
          shouldUpdate = true;
          return false;
        }
        return true;
      })
      .map((auftragsposition, rowIndex) => {
        if (
          (auftragsposition.auftptNum &&
            auftragsposition.auftptNum != rowIndex + 1) ||
          (auftragsposition.laufendePosition &&
            auftragsposition.laufendePosition != rowIndex + 1)
        ) {
          auftragsposition.auftptNum = rowIndex + 1;
          auftragsposition.laufendePosition = rowIndex + 1;
        }
        if (
          // Fall 2
          !auftragsposition.auftptNum &&
          !auftragspositionIsEmpty(auftragsposition)
        ) {
          shouldUpdate = true;
          return { ...auftragsposition, auftptNum: rowIndex + 1 };
        } else {
          // Fall 3 & 4
          return auftragsposition;
        }
      });

    if (shouldUpdate) {
      setCurrentAuftragspositionen(tmpAuftragspositionen);
    }
  };

  /**
   * Dient zur automatischen Kalkulation von Lademeter, Kubikmeter und Stellplätze
   * @param rowIndex aktueller Zeilenindex
   * @param attributName Key / Attributname des Elementes
   */
  const calculation = (rowIndex: number, attributName: string) => {
    const aufposData = [...currentAuftragspositionen];

    if (rowIndex == undefined) return;

    let verpackungseinheit = aufposData[rowIndex].verpackungseinheit;
    const lademittel = aufposData[rowIndex].lademittel;
    const anzahlLademittel = aufposData[rowIndex].lademittelAnzahl;
    const verpackung = aufposData[rowIndex].verpackung;
    const anzahlVerpackungen = aufposData[rowIndex].verpackungAnzahl;

    /**
     * Verpackungseinheit vorbelegen, falls möglich
     */
    //Verpackung + Lademittel = Verpackungseinheit manuell auswählen

    //eindeutig ausgewählt
    if (
      attributName === nameof<AuftragPositionModel>('lademittel') ||
      attributName === nameof<AuftragPositionModel>('verpackung') ||
      attributName === nameof<AuftragPositionModel>('lademittelAnzahl') ||
      attributName === nameof<AuftragPositionModel>('verpackungAnzahl')
    ) {
      if (config.mandantSpezi29) {
        if (
          (lademittel?.id && anzahlLademittel) ||
          (verpackung?.id && anzahlVerpackungen)
        ) {
          aufposData[rowIndex].verpackungseinheit =
            VERPACKUNGSEINHEIT_VERPACKUNG;
        }
      } else {
        if (
          verpackung?.id &&
          anzahlVerpackungen &&
          !lademittel?.id &&
          !anzahlLademittel
        ) {
          aufposData[rowIndex].verpackungseinheit =
            VERPACKUNGSEINHEIT_VERPACKUNG;
        } else if (
          (!verpackung?.id &&
            !anzahlVerpackungen &&
            lademittel?.id &&
            anzahlLademittel) ||
          (verpackung?.id &&
            anzahlVerpackungen &&
            lademittel?.id &&
            anzahlLademittel)
        ) {
          aufposData[rowIndex].verpackungseinheit =
            VERPACKUNGSEINHEIT_LADEMITTEL;
        }
      }
    }
    verpackungseinheit = aufposData[rowIndex].verpackungseinheit; //#84803

    /**
     * Lademeter / Stellplätze / Volumen errechnen
     */
    if (
      attributName === nameof<AuftragPositionModel>('laengeCM') ||
      attributName === nameof<AuftragPositionModel>('breiteCM') ||
      attributName === nameof<AuftragPositionModel>('hoeheCM') ||
      attributName === nameof<AuftragPositionModel>('lademittelAnzahl') ||
      attributName === nameof<AuftragPositionModel>('verpackungAnzahl') ||
      attributName === nameof<AuftragPositionModel>('verpackungseinheit')
    ) {
      const laenge = aufposData[rowIndex].laengeCM;
      const breite = aufposData[rowIndex].breiteCM;
      const hoehe = aufposData[rowIndex].hoeheCM;
      if (laenge && breite && hoehe && verpackungseinheit) {
        let anzahlEinheiten = 0;
        if (
          anzahlVerpackungen &&
          verpackungseinheit === VERPACKUNGSEINHEIT_VERPACKUNG
        ) {
          anzahlEinheiten = anzahlVerpackungen;
        } else if (
          anzahlLademittel &&
          verpackungseinheit === VERPACKUNGSEINHEIT_LADEMITTEL
        ) {
          anzahlEinheiten = anzahlLademittel;
        }
        /* #81766 if (!aufposData[rowIndex].volumenCBM)*/
        aufposData[rowIndex].volumenCBM =
          (laenge / 100) * (breite / 100) * (hoehe / 100) * anzahlEinheiten;
      }
      if (anzahlLademittel && laenge && breite && hoehe) {
        if (!aufposData[rowIndex].lademeter && config.isLademeterBerechnen)
          aufposData[rowIndex].lademeter = parseFloat(
            roundUpToFirstDecimalPlace(
              ((breite / 100) * (laenge / 100) * anzahlLademittel) / 2.4
            ).toFixed(2)
          );
        if (
          !aufposData[rowIndex].anzahlStellplaetze &&
          config.isStellplaetzeBerechnen
        )
          aufposData[rowIndex].anzahlStellplaetze = roundUpToNextHalf(
            (anzahlLademittel * ((laenge / 100) * (breite / 100))) / 2.4 / 0.4
          );
      }
      setCurrentAuftragspositionen(aufposData);
    }
  };

  return (
    <GridCellWrapper
      classes='auftragspos'
      label='Auftragspositionen'
      name={'auftragspositionen'}
    >
      <Table
        tableConfig={tableConfig}
        edit={true}
        name={'auftragspositionen'}
        setTableConfig={setTableConfig}
        data={currentAuftragspositionen}
        setData={setCurrentAuftragspositionen}
        defaultEmptyRow={{ ...positionDefaultRow }}
        tabSkipIndices={[0]}
        tableCellOnBlur={calculation}
        selectByAllTablecells={false}
        classNameSelect={'lademittel'}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
      />
    </GridCellWrapper>
  );
};

const initData = (): Array<any> => {
  return [
    {
      elementId: undefined,
      id: undefined,
      artikelNummer: undefined,
      stellplaetze: undefined,
      warengut: {},
      nettoGewicht: undefined,
      laufendePosition: undefined,
      anzahlJeVerpackung: undefined,
      anzahlStangen: undefined,
      anzahlTlStangen: undefined,
      auftragId: undefined,
      editable: undefined,
      festfrachtGewicht: undefined,
      mandant: undefined,
      gefahrgut: undefined,
      lademittelBezeichnung: undefined,
      lieferschein: undefined,
      referenz: undefined,
      txrId: undefined,
      waehrungBezeichnung: undefined,
      zerbrechlich: undefined,

      auftptNum: undefined,
      verpackungAnzahl: undefined,
      verpackung: { elementId: 0, value: '' },
      lademittelAnzahl: undefined,
      lademittel: { elementId: 0, value: '' },
      verpackungseinheit: undefined,
      warengutBezeichnung: undefined,
      bruttoGewicht: undefined,
      mitGefahrguetern: false,
      auftragsgefahrgueter: [],
      zeichenNummer: undefined,
      versicherungswert: undefined,
      waehrungVersicherungswert: undefined,
      warenwert: undefined,
      warenwertWaehrung: undefined,
      lademeter: undefined,
      anzahlStellplaetze: undefined,
      volumenCBM: undefined,
      laengeCM: undefined,
      breiteCM: undefined,
      hoeheCM: undefined,
    },
  ];
};

export const positionDefaultRow: any = {
  auftptNum: undefined,
  verpackungAnzahl: undefined,
  verpackung: undefined,
  lademittelAnzahl: undefined,
  lademittel: undefined,
  verpackungseinheit: undefined,
  warengutBezeichnung: undefined,
  bruttoGewicht: undefined,
  mitGefahrguetern: false,
  auftragsgefahrgueter: [],
  zeichenNummer: undefined,
  lieferschein: undefined,
  versicherungswert: undefined,
  waehrungVersicherungswert: undefined,
  warenwert: undefined,
  warenwertWaehrung: undefined,
  lademeter: undefined,
  anzahlStellplaetze: undefined,
  volumenCBM: undefined,
  laengeCM: undefined,
  breiteCM: undefined,
  hoeheCM: undefined,
};

const mapStateToProps = (state: StateModel) => ({
  resetToggle: state.Auftragserfassung.resetToggle,
  currentAuftragspositionen: state.Auftragserfassung.currentAuftragpos,
  mandant: state.Auftragserfassung.mandant,
  lademittel: state.Stammdaten.lademittel,
  verpackungen: state.Stammdaten.verpackungen,
  waehrungen: state.Stammdaten.waehrungen,
  isMetro: state.UserSession.isMetro,
  isBexity: state.Config.clientKunde?.toUpperCase() == 'BEXITY',
  config: state.Config,
});

export default connect(mapStateToProps, {
  setCurrentAuftragspositionen,
  getLademittelOnlyGGVSOrWithout,
  getVerpackungenOnlyGGVSOrWithout,
  getWaehrungen,
})(Auftragspositionen);
